//Todo => Team data selectors
export const selectTeamMembers = (state) => state.team.teamMembers;
export const selectAvailableRoles = (state) => state.team.availableRoles;

//Todo => Statistics selectors
export const selectTotalMembers = (state) => state.team.totalMembers;
export const selectActiveMembers = (state) => state.team.activeMembers;
export const selectInactiveMembers = (state) => state.team.inactiveMembers;

//Todo => Loading state selectors
export const selectIsLoading = (state) => state.team.isLoading;
export const selectIsCreating = (state) => state.team.isCreating;
export const selectIsUpdating = (state) => state.team.isUpdating;
export const selectIsDeleting = (state) => state.team.isDeleting;

//Todo => Error state selectors
export const selectError = (state) => state.team.error;
export const selectCreateError = (state) => state.team.createError;
export const selectUpdateError = (state) => state.team.updateError;
export const selectDeleteError = (state) => state.team.deleteError;

//Todo => Computed selectors
export const selectTeamMemberById = (state, id) => 
  state.team.teamMembers.find(member => member.id === id);

export const selectTeamMembersByRole = (state, role) => 
  state.team.teamMembers.filter(member => member.role.toLowerCase() === role.toLowerCase());

// Updated to handle both status formats (active/Active, inactive/Inactive)
export const selectActiveTeamMembers = (state) => 
  state.team.teamMembers.filter(member => 
    member.status === 'Active' || member.status === 'active'
  );

export const selectInactiveTeamMembers = (state) => 
  state.team.teamMembers.filter(member => 
    member.status === 'Inactive' || member.status === 'inactive'
  );

//Todo => Permission helpers
export const selectRolePermissions = (state, roleValue) => {
  const role = state.team.availableRoles.find(r => r.value === roleValue);
  return role ? role.permissions : [];
};

export const selectHasAnyLoadingState = (state) => 
  state.team.isLoading || state.team.isCreating || state.team.isUpdating || state.team.isDeleting;

export const selectHasAnyError = (state) => 
  !!(state.team.error || state.team.createError || state.team.updateError || state.team.deleteError);

//Todo => Additional helper selectors for role management
export const selectCanCreateMembers = (state) => state.team.canCreateMembers;

export const selectTeamStatistics = (state) => ({
  total: state.team.totalMembers,
  active: state.team.activeMembers,
  inactive: state.team.inactiveMembers,
  activePercentage: state.team.totalMembers > 0 
    ? Math.round((state.team.activeMembers / state.team.totalMembers) * 100) 
    : 0
}); 